;(function () {
  angular.module('contrast.browser').directive('isIeClass', function ($window) {
    'ngInject'

    return {
      scope: true,
      restrict: 'A',
      link: function (scope, elem, attr) {
        if (isIE()) {
          elem.addClass(attr.isIeClass)
        }
      }
    }

    function isIE() {
      return (
        $window.navigator.userAgent.indexOf('MSIE') > -1 ||
        $window.navigator.userAgent.indexOf('Trident') > -1 ||
        $window.navigator.userAgent.indexOf('Edge') > -1
      )
    }
  })
})()
